export const PostPasswordController = {
    verify(): void {},
};
